(ns practitest.frontend.account-dashboard-settings.views
  (:require
   [practitest.frontend.account-dashboard-settings.events]
   [practitest.frontend.account-dashboard-settings.subs]
   [clojure.string               :as string]
   [re-frame.core                :as re-frame]
   [practitest.frontend.components.markdown2 :as markdown2]
   [practitest.frontend.common.dom :as dom]))

(defn event->value [event]
  (-> event .-target .-value))

(defn save-button [key val]
  ;; TODO: switch (all buttons) to new Button component
  [:button.btn.btn-primary.btn-sm.ml-5
   {:on-click (fn [e]
                (.preventDefault e)
                (re-frame/dispatch [:account-dashboard-settings/update-account]))}
   "Save"])

(defn cancel-button [key val]
  [:button.btn.btn-secondary.btn-sm.ml-5
   {:on-click (fn [e]
                (.preventDefault e)
                (js/location.reload()))}
   "Cancel"])

(defn add-button [key val]
  (let [display-list (re-frame/subscribe [:account-dashboard-settings/get-list :display-list])
        disable      (> (count @display-list) 7)]
    [:button.btn.btn-success.small-btn
     {:on-click (fn [e]
                  (.preventDefault e)
                  (re-frame/dispatch [:account-dashboard-settings/add-val key val]))
      :class (if disable "disabled" "")}
     [:i.fa.fa-plus] [:span
                      @display-list]]))

(defn remove-button [key val]
  [:button.btn.btn-danger.small-btn
   {:on-click (fn [e]
                (.preventDefault e)
                (re-frame/dispatch [:account-dashboard-settings/remove-val key val]))}
   [:i.fa.fa-minus]])

(defn list-vals [listvals button]
  [:div
   (for [[key val] listvals]
     ^{:key key}
     [:li.row.margin-0.acdBox.flex-container
      [:div.col-11.oneline [:span
                            {:title val}
                            val]]
      [:div.col-1.float-right [button key val]]])])

(defn picklist [header listvals button serach-key]
  (let [serach-val (re-frame/subscribe [:account-dashboard-settings/get-search-val serach-key])]
    [:div.col-md-6
     [:h4.sub-title header]
     (when (or (> (count listvals) 2) (not (string/blank? @serach-val)))
       [:div.input-group.ng_filter_css
        [:input.form-control {:placeholder "start typing for filtering..."
                              :on-change    (fn [e]
                                              (.preventDefault e)
                                              (let [val (event->value e)]
                                                (re-frame/dispatch [:account-settings/update-search-val serach-key val])))}]
        [:div.input-group-addon
         [:i.fa.fa-search]]])
     [:ul.lists.list-group
      [list-vals listvals button]]]))

(defn get-list [display-list display-serach-key header button]
  (let [list (re-frame/subscribe [:account-dashboard-settings/get-list display-list display-serach-key])]
    [picklist header @list button display-serach-key]))

(defn dashbord-display []
  [:div.row
   [:div#account_dashboards_items.col-lg-6.col-md-6
    [:div.row.mt-3
     [get-list :avaliable-list :avaliable-serach-key "Available Items:" add-button]
     [get-list :display-list :display-serach-key "Display Items:" remove-button]]]])

(defn dashbord-header []
  [:div.row
   [:div.col-lg-6.col-md-6.mt-10
    [:h4.sub-title "Account Graph Area:"]]])

(defn dashbord-sub-header []
  [:div.row
   [:div.col-lg-6.col-md-6
    [:span "Select the dashboard items that you want to see in the account landing page for all your account users."]]])

(defn regular-textarea []
  (let [account-message-sub   (re-frame/subscribe [:account-dashboard-settings/account-message])
        rtl?                  (re-frame/subscribe [:account-dashboard-settings/rtl?])]
    [:textarea.form-control
     {:rows           2
      :cols          40
      :value @account-message-sub
      :on-change     (fn [e]
                       (.preventDefault e)
                       (let [val (event->value e)]
                         (re-frame/dispatch [:account-dashboard-settings/set-account-message val])))
      :dir           (if @rtl? "rtl" "")}]))

(defn markdown-container []
    [markdown2/markdown-editor {:editing?      true
                                :value         @(re-frame/subscribe [:account-dashboard-settings/account-message])
                                :class         (dom/classes-pairs :description false)
                                :on-change   (fn [value]
                                               (re-frame/dispatch [:account-dashboard-settings/set-account-message value]))
                                :initial-edit  false}])

(defn mde-textarea []
  (let [markdown-support?     @(re-frame/subscribe [:account-dashboard-settings/markdown-support?])]
    [:div.row
     [:div.col-lg-6.col-md-6
      [:div.description_mk.simplemde-container
       (if markdown-support?
         [markdown-container]
         [regular-textarea])]]]))

(defn account-note []
  (let [is-enable (re-frame/subscribe [:account-dashboard-settings/account-message-enable])]
    [:div.row
     [:div.col-lg-6.col-md-6
      [:span "Write a note to all users in this account, that will appear in their landing page"]
      [:div#custom-switch.custom-control
       {:style {:float "right"}}
       [:label.custom-control-label.enable-color {:for "customSwitch"} "Enable"]
       [:i.fa.fa-2x
        {:class (if @is-enable "fa-toggle-on" "fa-toggle-off")
         :type "checkbox"
         :checked @is-enable
         :on-click #(re-frame/dispatch [:account-dashboard-settings/toggle-enable-val])}]
       [:label.custom-control-label.disable-color {:for "customSwitch"} "Disable"]]]]))

(defn account-note-header []
  [:div.row
   [:div.col-lg-6.col-md-6.mt-2
    [:h4.sub-title "Account Note"]]])

(defn account-header []
  [:div.row
   [:div.col-lg-6.col-md-6
    [:legend {:class "mouseux-legend"} "Account Info Display Customization"]]])

(defn message-container [message-key class]
  (when-let [message @(re-frame/subscribe [:account-dashboard-settings/get-message message-key])]
    [:div.row
     [:div.col-6
      [:div.alert.acc-set-message-position
       {:role "alert"
        :class class}
       message]]]))

(defn db []
  (let [db @(re-frame/subscribe [:account-dashboard-settings/db])]
    [:div.row
     [:div.col-6
      [:div.alert.message-position
       {:role "alert"}
       db]]]))


(defn main-panel []
  [:div.old-frontend-container.mt-0.ms-0
   [:div.container-fluid.old-frontend-inner-container.padded-dashboard-settings
  [:div
   ;; [db]
   [message-container :failure-message "alert-danger"]
   [message-container :success-message "alert-success"]
   [account-header]
   [account-note-header]
   [account-note]
   [mde-textarea]
   [dashbord-header]
   [dashbord-sub-header]
   [dashbord-display]
   [:div.row
    [:div.col-lg-6.col-md-6
     [:div.float-right.button-row
      [cancel-button]
      [save-button]]]]]]])
